import script from "./HeaderNavHomepage.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNavHomepage.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNavHomepage.vue?vue&type=style&index=0&id=6edfc7e2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edfc7e2"]])

export default __exports__